// App.js
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Home from "./pages/Home";
import Posts from "./pages/Posts";
import Pictures from "./pages/Pictures";
import SinglePicture from "./pages/SinglePicture";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Single from "./pages/Single";
import Write from "./pages/Write";
import Drafts from "./pages/Drafts";
import WritePicture from "./pages/WritePicture";
import EditNowPlaying from "./pages/EditNowPlaying";
import EditLinks from "./pages/EditLinks";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const Layout = () => {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/posts",
        element: <Posts />,
      },
      {
        path: "/post/:id",
        element: <Single />,
      },
      {
        path: "/pictures",
        element: <Pictures />,
      },
      {
        path: "/picture/:id",
        element: <SinglePicture />,
      },
{
        path: "/write",
        element: <Write />,
      },
      {
        path: "/drafts",
        element: <Drafts />,
      },
{
        path: "/write-picture",
        element: <WritePicture />,
      },
{
        path: "/edit-song",
        element: <EditNowPlaying />,
      },
      {
        path: "/edit-links",
        element: <EditLinks />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
]);

function App() {
  return (
    <div className="app">
      <div className="container">
        <RouterProvider router={router} />
      </div>
    </div>
  );
}

export default App;
